import type { ComponentChildren, JSX } from "preact";
import { classNames } from "@gss/common/classNames";

interface Props {
    className?: string;
    small?: boolean;
    children: ComponentChildren;
}

export function InputGroup({ className, small, children }: Props): JSX.Element {
    return (
        <div
            className={classNames(
                "input-group",
                small && "input-group-sm",
                className,
            )}
        >
            {children}
        </div>
    );
}
